<script setup lang="ts">
</script>

<template>
 <div class="min-h-screen bg-background text-foreground transition-colors duration-300">
 <slot />
 </div>
</template>
